// Shared addresses only: safe to import from the standalone authorization page.
export const META_NATIVE_SIGNUP_PATH = '/whatsapp-meta-signup';
export const META_NATIVE_SIGNUP_URL = `https://empresa.xeguei.com.br${META_NATIVE_SIGNUP_PATH}`;
export const META_NATIVE_API = 'https://19hnit6dtk.execute-api.sa-east-1.amazonaws.com/prd/whatsapp/meta/onboarding/native';
